//payment cancel page

import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ARROW } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';

export default function PaymentCancelPage() {
  return (
    <Box sx={{ mt: '-60px' }}>
      <Box>
        <Typography variant='h6' gutterBottom>
          <Link to={'/subscriptions'}>Subscriptions</Link> {ARROW} Failed
          payment
        </Typography>
      </Box>
      <Typography variant='h6'>
        Your payment has not gone through successfully. Please review your
        payment information and attempt the transaction again.
      </Typography>
      <FloatingButton/>
    </Box>
  );
}
